import './basic-item-card.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

import { Item } from '@skinsoft/types';
import { itemSelectors } from '@skinsoft/selectors';

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { Touchable, LocalizedString } from '@skinsoft/ui';
import { Media } from '@skinsoft/ui/src/item-card/media';
import { BASIC_ITEM_CARD_TITLE_CLICKED } from '../../../events';

export interface DesactivatedFields {
    title?: boolean,
    itemType?: boolean,
}

@Component({
    components: {
        sMedia: Media,
        sLocalizedString: LocalizedString,
        sTouchable: Touchable,
    },
    props: {
        item: {
            type: Object as PropType<Item>,
        },
        excludedFields: {
            type: Object as PropType<DesactivatedFields>,
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
        clickableTitle: {
            type: Boolean,
            default: false,
        }
    },
    template: require('./basic-item-card.html')
})
export class BasicItemCard extends ReactiveVue {
    private item: Item
    private excludedFields: DesactivatedFields
    private actionsAvailable: boolean
    private clickableTitle: boolean

    public titleClickIcon = faExternalLinkAlt

    private onTitleClicked() {
        if(this.clickableTitle) {
            this.$emit(BASIC_ITEM_CARD_TITLE_CLICKED)
        } else {
            this.$emit('click')
        }
    }

    private get inventoryNumber(): string {
        return itemSelectors.inventoryNumber(this.item) ?? ""
    }

    private get title(): string {
        return itemSelectors.federatedTitle(this.item, this.getAppLocale())
    }

    private get mediaId(): string {
        return itemSelectors.media(this.item) ?? ""
    }

    private get itemType(): string {
        const type = itemSelectors.type(this.item)
        if(type) {
            return this.getReadableCardType(type) ?? ""
        }

        return ""
    }

    private get showTitle(): boolean {
        return (this.excludedFields?.title) !== true
    }

    private get showItemType(): boolean {
        return (this.excludedFields?.itemType) !== true
    }

    private getReadableCardType(cardType: string, defaultCardTypeKey: string = 'museum'): string {
        const cardTypeKeyMatcher = /^.+?([A-Z][a-z]+)/;
        const cardTypeMatchResult = cardType.match(cardTypeKeyMatcher)
        const typeId = cardTypeMatchResult && cardTypeMatchResult.length > 1 ? cardTypeMatchResult[1].toLowerCase() : defaultCardTypeKey
        return this.$t(`entity.itemTypes.${typeId}`) as string
    }
}